import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import React from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header";
import SideMenu from "./components/SideMenu/SideMenu";
import { RequireAuth } from "./routesFunctions";
import Dashboard from "./screens/dashboard/Dashboard";
import Login from "./screens/auth/Login";
import BlogEdit from "./screens/blog/BlogEdit";
import BlogList from "./screens/blog/BlogList";
import BlogPreview from "./screens/blog/BlogPreview";
import NewBlog from "./screens/blog/NewBlog";
import ErrorBoundary from "./screens/errorPages/ErrorBoundary";
import NoAuthority from "./screens/errorPages/NoAuthority";
import NotFound from "./screens/errorPages/NotFound";
import DialogDetails from "./screens/message/DialogDetails";
import DialogList from "./screens/message/DialogList";
import OrderDetails from "./screens/order/OrderDetails";
import OrderList from "./screens/order/OrderList";
import ProductDetails from "./screens/product/ProductDetails";
import ProductList from "./screens/product/ProductList";
import UserDetails from "./screens/user/UserDetails";
import UserList from "./screens/user/UserList";
import BrandList from "./screens/watch/BrandList";
import EditBrand from "./screens/watch/EditBrand";
import EditWatch from "./screens/watch/EditWatch";
import ModelList from "./screens/watch/ModelList";
import NewBrand from "./screens/watch/NewBrand";
import NewModel from "./screens/watch/NewModel";
import NewWatch from "./screens/watch/NewWatch";
import WatchList from "./screens/watch/WatchList";
import AgreementEdit from "./screens/webContent/AgreementEdit";
import AgreementList from "./screens/webContent/AgreementList";
import CareerEdit from "./screens/webContent/CareerEdit";
import CareerList from "./screens/webContent/CareerList";
import CompanyInfoEdit from "./screens/webContent/CompanyInfoEdit";
import CompanyInfoList from "./screens/webContent/CompanyInfoList";
import EditQuestion from "./screens/webContent/FAQ/EditQuestion";
import FaqList from "./screens/webContent/FAQ/FaqList";
import NewQuestion from "./screens/webContent/FAQ/NewQuestion";
import ImageEdit from "./screens/webContent/ImageEdit";
import ImageList from "./screens/webContent/ImageList";
import NewCareer from "./screens/webContent/NewCareer";
import NewProduct from "./screens/product/NewProduct";
import EditProduct from "./screens/product/EditProduct";
import NewUser from "./screens/user/NewUser";
import EditUser from "./screens/user/EditUser";
import AdsList from "./screens/webContent/ads/AdsList";
import NewAd from "./screens/webContent/ads/NewAd";
import EditAd from "./screens/webContent/ads/EditAd";


function App() {
  const SidebarLayout = () => (
    <div>
      <Header />
      <div
        style={{
          display: "flex",
          height: "calc(100vh - 50px)",
          color: "var(--font-color)",
          fontSize: "var(--main-size)",
          position: "relative",
        }}
      >
        <SideMenu />
        <Outlet />
      </div>
    </div>
  );

  const routes = [
    { menuName: "dashboard", path: "/", component: <Dashboard /> },
    { menuName: "Blog list", path: "/blogs", component: <BlogList /> },
    { menuName: "New Blog", path: "/blog/new", component: <NewBlog /> },
    {
      menuName: "Edit Blog",
      path: "/blog/edit/:id",
      component: <BlogEdit />,
    },
    {
      menuName: "Preview Blog",
      path: "/blog/preview/:id",
      component: <BlogPreview />,
    },
    { menuName: "Brand List", path: "/watch/brands", component: <BrandList /> },
    { menuName: "Watch List", path: "/watches", component: <WatchList /> },
    { menuName: "New Watch", path: "/watch/new", component: <NewWatch /> },
    { menuName: "Edit Watch", path: "/watch/edit/:id", component: <EditWatch /> },
    { menuName: "New Brand", path: "/watch/brand/new", component: <NewBrand /> },
    { menuName: "Edit Brand", path: "/watch/brand/edit/:id", component: <EditBrand /> },
    { menuName: "Model List", path: "/watch/models", component: <ModelList /> },
    { menuName: "New Model", path: "/watch/model/new", component: <NewModel /> },
    // { menuName: "Edit Watch", path: "/watch/edit/:id", component: <EditProduct /> },

    { menuName: "Standard User List", path: "/users", component: <UserList userType={"Normal User"}/> },
    { menuName: "Private Seller List", path: "/users/private-seller", component: <UserList userType={"Verified Seller"}/> },
    { menuName: "Dealer List", path: "/users/dealer", component: <UserList userType={"Dealer"}/> },
    { menuName: "User Details", path: "/users/details/:id", component: <UserDetails /> },
    { menuName: "New User", path: "/users/new", component: <NewUser /> },
    { menuName: "Edit User", path: "/users/edit/:id", component: <EditUser /> },
    // products
    { menuName: "Product List", path: "/products", component: <ProductList/> },
    { menuName: "Product Details", path: "/products/details/:id", component: <ProductDetails /> },
    { menuName: "New Product", path: "/products/new/", component: <NewProduct /> },
    { menuName: "Edit Product", path: "/products/edit/:id", component: <EditProduct /> },

    // orders
    { menuName: "Order List", path: "/orders", component: <OrderList /> },
    { menuName: "Order Details", path: "/orders/details/:id", component: <OrderDetails /> },
     // messages
     { menuName: "Messages", path: "/messages", component: <DialogList/> },
     { menuName: "Dialog", path: "/messages/details/:id", component: <DialogDetails /> },
     // web content
     { menuName: "FAQ", path: "/web-content/faq", component: <FaqList /> },
     { menuName: "FAQ", path: "/web-content/faq/new", component: <NewQuestion /> },
     { menuName: "FAQ", path: "/web-content/faq/edit/:id", component: <EditQuestion /> },

      // web content -ads
      { menuName: "Ads", path: "/web-content/ads", component: <AdsList /> },
      { menuName: "Ads", path: "/web-content/ads/new", component: <NewAd /> },
      { menuName: "Ads", path: "/web-content/ads/edit/:id", component: <EditAd /> },
  
     { menuName: "Website Images", path: "/web-content/images", component: <ImageList /> },
     { menuName: "Update Images", path: "/web-content/images/edit/:id", component: <ImageEdit /> },
     { menuName: "Website Agreements", path: "/web-content/agreements", component: <AgreementList /> },
     { menuName: "Update Agreements", path: "/web-content/agreements/edit/:id", component: <AgreementEdit /> },
     { menuName: "Edit Career", path: "/web-content/career/edit/:id", component: <CareerEdit /> },
     { menuName: "New Career", path: "/web-content/career/new", component: <NewCareer /> },
     { menuName: "Career List", path: "/web-content/career", component: <CareerList /> },
     { menuName: "Company Details", path: "/web-content/company-details", component: <CompanyInfoList /> },
     { menuName: "Update Company Detail", path: "/web-content/company-details/edit/:id", component: <CompanyInfoEdit /> },
  ];

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route element={<SidebarLayout />}>
            {routes.map((route, index) => (
              <Route
                key={index}
                exact
                path={route.path}
                element={
                  <RequireAuth permisson={true}>{route.component}</RequireAuth>
                }
              />
            ))}
          </Route>
          {/* <Route exact path="/billing" element={<BillingScreen />} /> */}
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/no_permission" element={<NoAuthority />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
